import { render } from "./TerminosYCondiciones.vue?vue&type=template&id=7b03d30b&scoped=true"
import script from "./TerminosYCondiciones.vue?vue&type=script&lang=js"
export * from "./TerminosYCondiciones.vue?vue&type=script&lang=js"

import "./TerminosYCondiciones.vue?vue&type=style&index=0&id=7b03d30b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b03d30b"]])

export default __exports__